import { Link } from "react-router-dom";
import { Mountain, Mail, HandHelping, Target, Share2, BookOpen } from "lucide-react";
import { useState } from "react";

export const Footer = () => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareData = {
      title: "ekvalleys.com",
      text: "Check out ekvalleys.com — the East Kootenay community business directory!",
      url: window.location.origin,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== "AbortError") {
          fallbackCopy();
        }
      }
    } else {
      fallbackCopy();
    }
  };

  const fallbackCopy = () => {
    navigator.clipboard.writeText(window.location.origin).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <footer className="bg-[#1A2F23] text-white py-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo & Brand */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
              <Mountain className="w-6 h-6 text-[#D4A017]" strokeWidth={1.5} />
              <span className="font-heading text-lg font-bold">ekvalleys.com</span>
            </Link>
            <p className="text-white/70 text-sm">East Kootenay, BC</p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-8 text-sm">
            <Link to="/directory" className="text-white/70 hover:text-[#D4A017] transition-colors" data-testid="footer-directory">Directory</Link>
            <Link to="/list-business" className="text-white/70 hover:text-[#D4A017] transition-colors" data-testid="footer-list-business">List Your Business</Link>
            <Link to="/about" className="text-white/70 hover:text-[#D4A017] transition-colors" data-testid="footer-about">About</Link>
            <Link to="/volunteer" className="flex items-center gap-1 text-white/70 hover:text-[#D4A017] transition-colors" data-testid="footer-volunteer">
              <HandHelping className="w-3.5 h-3.5" />Volunteer
            </Link>
            <Link to="/marketplace" className="flex items-center gap-1 text-white/70 hover:text-[#D4A017] transition-colors" data-testid="footer-marketplace">
              <Target className="w-3.5 h-3.5" />Marketplace
            </Link>
            <button
              onClick={handleShare}
              className="flex items-center gap-1 text-white/70 hover:text-[#D4A017] transition-colors cursor-pointer bg-transparent border-none p-0 text-sm"
              data-testid="footer-share-app"
            >
              <Share2 className="w-3.5 h-3.5" />
              {copied ? "Link Copied!" : "Share"}
            </button>
            <a
              href="https://substack.com/@ekvalleys?invite"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-white/70 hover:text-[#D4A017] transition-colors"
              data-testid="footer-substack"
            >
              <BookOpen className="w-3.5 h-3.5" />Substack
            </a>
          </div>

          {/* Contact */}
          <div className="flex items-center gap-2 text-white/70">
            <Mail className="w-4 h-4" />
            <a href="mailto:info@ekvalleys.com" className="hover:text-[#D4A017] transition-colors text-sm" data-testid="footer-email">
              info@ekvalleys.com
            </a>
          </div>
        </div>

        {/* Legal / Signoff */}
        <div className="mt-10 pt-6 border-t border-white/10 text-center space-y-2">
          <p className="text-white/50 text-sm italic" data-testid="footer-ktunaxa">Taxta hu¢ ǂa ʔupxniskiǂni</p>
          <p className="text-white/60 text-sm italic" data-testid="footer-ktunaxa-goodbye">Anwunikit</p>
          <p className="text-white/70 text-sm font-heading font-semibold">ekvalleys.com</p>
          <p className="text-white/40 text-xs">EKValleys - Copyright 2026</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
